// ISO-8601 YYYY-MM-DD string validator. Backend's `dateString` regex accepts
// semantically-invalid values (e.g. "2025-02-29", "2026-13-45") that JS
// Date silently rolls over. This client-side guard catches them before a
// form submit so the user gets a local error instead of persisted garbage.
// The part-match re-verify is the key step: parsing can return a valid
// Date object that represents a different day than the input.

export function isValidIsoDate(
  v: string | undefined | null,
): boolean {
  if (!v) return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
  const d = new Date(`${v}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return false;
  const [y, m, day] = v.split("-").map(Number);
  return (
    d.getUTCFullYear() === y &&
    d.getUTCMonth() === m - 1 &&
    d.getUTCDate() === day
  );
}
